import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { notifications } from '@mantine/notifications'

import { BackgroundSection } from '@/layouts/DefaultLayout/components/BackgroundSection/BackgroundSection'
import { Content } from '@/layouts/DefaultLayout/components/Content/Content'

import { CommonRoutePathsEnum } from '@/modules/common/routes/commonRouteConfig.types'
import { LoginRoutePathsEnum } from '@/modules/login/routes/loginRouteConfig.types'

import { Text } from '@/components/Text/Text'

import { useRolanWealthServiceVerifyControllerVerifyEmail } from '@/__generated__/queries'

export function Component() {
  const hasVerifiedRef = useRef(false)

  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const token = searchParams.get('token')
  const email = decodeURIComponent(searchParams.get('email') || '')

  const verificationMutation = useRolanWealthServiceVerifyControllerVerifyEmail(
    {
      onSettled: () => {
        navigate(LoginRoutePathsEnum.LOGIN)
      },
      onSuccess: () => {
        notifications.show({
          color: 'green',
          message: `Email ${email} has been verified. You can now login.`,
          title: 'Email verified successfully',
        })
      },
    },
  )

  useEffect(() => {
    if (!email || !token) {
      navigate(CommonRoutePathsEnum.REDIRECTED_TO_NOT_FOUND)
    }
  }, [email, navigate, token])

  useEffect(() => {
    if (email && token && !hasVerifiedRef.current) {
      hasVerifiedRef.current = true

      verificationMutation.mutate({
        requestBody: {
          email,
          token,
        },
      })
    }
  }, [email, token, verificationMutation])

  return (
    <>
      <BackgroundSection image="register_image.png" />

      <Content>
        <Text>Verification in progress. Please wait...</Text>
      </Content>
    </>
  )
}
